import { render, staticRenderFns } from "./PurchaseInvoiceListView.vue?vue&type=template&id=d84812f8"
import script from "./PurchaseInvoiceListView.vue?vue&type=script&lang=js"
export * from "./PurchaseInvoiceListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports